import React, { lazy } from 'react';

const IdentityComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-identity" */ './identity')
);

export const IdentityRoute = () => {
  return <IdentityComponent />;
};
